var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27;
import { jsx as _jsx } from "react/jsx-runtime";
import darkScrollbar from '@mui/material/darkScrollbar';
import { createTheme } from '@mui/material/styles';
import ArrowDown from '../../icons/ArrowDown';
import Check from '../../icons/Check';
import Error from '../../icons/Error';
import Info from '../../icons/Info';
import Warning from '../../icons/Warning';
import wdsFigmaExport from './figma-exports/default-theme/theme.json';
/**
 * Returns MUI overrides so that the Alert colours match Figma
 * @see https://www.figma.com/design/54pQgi6iKnhgI2REIUGekY/Seequent-Material-2-Design-Kit?node-id=10990-229266&t=zsy9NowuTKcuxpEN-0
 */
function fixAlertColours(severity, variant) {
    return ({ theme }) => {
        if (!severity || !variant || !wdsFigmaExport) {
            // Just in case (keeping TSC happy)
            return {};
        }
        const { background, color } = wdsFigmaExport.colorSchemes[theme.palette.mode].palette._components.alert[severity];
        // Dark mode text colour is borked in the theme, so this overrides it to be the default text colour (white ish)
        const textColor = theme.palette.mode === 'light' ? color : theme.palette.text.primary;
        if (variant === 'outlined') {
            return {
                borderColor: theme.palette[severity].main,
                color: textColor,
            };
        }
        if (variant === 'filled') {
            return {
                backgroundImage: 'none',
            };
        }
        // Variant: standard
        return {
            backgroundColor: background,
            color: textColor,
        };
    };
}
// Blue-tinted grey scale. The .light values are the canonical low-to-high
// (light-to-dark) ramp used for both palette.grey and evo-colors CSS variables.
// The .dark values are the semantically inverted equivalents used only by
// evo-colors (e.g. grey-700 dark = light colour for dark-mode foregrounds).
//
// palette.grey uses .light for BOTH modes so that MUI internals (Tooltip,
// Skeleton, Switch, etc.) that index by number always get the right shade.
const greys = {
    50: { light: '#FBFBFC', dark: '#1D1F23' },
    100: { light: '#F5F5F6', dark: '#3B3F47' },
    200: { light: '#ECEDF0', dark: '#575E68' },
    300: { light: '#DCDEE2', dark: '#696F7E' },
    400: { light: '#B6BAC2', dark: '#9499A5' },
    500: { light: '#9499A5', dark: '#B6BAC2' },
    600: { light: '#696F7E', dark: '#DCDEE2' },
    700: { light: '#575E68', dark: '#ECEDF0' },
    800: { light: '#3B3F47', dark: '#F5F5F6' },
    900: { light: '#1D1F23', dark: '#FBFBFC' },
};
// Always use the .light (non-inverted) values for palette.grey so that low
// numbers are light and high numbers are dark regardless of colour scheme,
// which is what MUI components expect when they reference palette.grey[50], etc.
const paletteGrey = Object.fromEntries(Object.entries(greys).map(([key, value]) => [key, value.light]));
// Pre-computed blue-tinted elevation colours from the Figma export.
// Wrapped as linear-gradient so MUI applies them via background-image on Paper.
// MUI requires a fixed-length tuple of exactly 25 elements (elevations 0–24).
const darkOverlays = [
    'linear-gradient(#101114, #101114)', // 0
    'linear-gradient(#1B1D21, #1B1D21)', // 1
    'linear-gradient(#202226, #202226)', // 2
    'linear-gradient(#222428, #222428)', // 3
    'linear-gradient(#23262B, #23262B)', // 4
    'linear-gradient(#26292E, #26292E)', // 5
    'linear-gradient(#282B30, #282B30)', // 6
    'linear-gradient(#282B30, #282B30)', // 7
    'linear-gradient(#2A2D32, #2A2D32)', // 8
    'linear-gradient(#2A2D32, #2A2D32)', // 9
    'linear-gradient(#2D3035, #2D3035)', // 10
    'linear-gradient(#2D3035, #2D3035)', // 11
    'linear-gradient(#2E3138, #2E3138)', // 12
    'linear-gradient(#2E3138, #2E3138)', // 13
    'linear-gradient(#2E3138, #2E3138)', // 14
    'linear-gradient(#2E3138, #2E3138)', // 15
    'linear-gradient(#31343B, #31343B)', // 16
    'linear-gradient(#31343B, #31343B)', // 17
    'linear-gradient(#31343B, #31343B)', // 18
    'linear-gradient(#31343B, #31343B)', // 19
    'linear-gradient(#31343B, #31343B)', // 20
    'linear-gradient(#33363D, #33363D)', // 21
    'linear-gradient(#33363D, #33363D)', // 22
    'linear-gradient(#33363D, #33363D)', // 23
    'linear-gradient(#33363D, #33363D)', // 24
];
// a function to generate the custom colors the theme needs
function generateCustomColors() {
    const colors = {
        'blue-900': { light: '#265C7F', dark: '#E3F5F9' },
        'blue-800': { light: '#317BA1', dark: '#B8F6F0' },
        'blue-700': { light: '#358CB4', dark: '#8DD5E7' },
        'blue-600': { light: '#3E9FC7', dark: '#6AC5DE' },
        'blue-500': { light: '#46ACD5', dark: '#55B8D9' },
        'blue-400': { light: '#55B8D9', dark: '#46ACD5' },
        'blue-300': { light: '#6AC5DE', dark: '#3E9FC7' },
        'blue-200': { light: '#8DD5E7', dark: '#358CB4' },
        'blue-100': { light: '#B8E6F0', dark: '#317BA1' },
        'blue-50': { light: '#E3F5F9', dark: '#265C7F' },
        'grey-900': greys[900],
        'grey-800': greys[800],
        'grey-700': greys[700],
        'grey-600': greys[600],
        'grey-500': greys[500],
        'grey-400': greys[400],
        'grey-300': greys[300],
        'grey-200': greys[200],
        'grey-100': greys[100],
        'grey-50': greys[50],
    };
    const light = {};
    const dark = {};
    for (const [name, value] of [...Object.entries(colors)]) {
        light[`evo-colors-${name}`] = value.light;
        dark[`evo-colors-${name}`] = value.dark;
    }
    return { light, dark };
}
const fontFamily = 'Inter, "Helvetica Neue", Arial, sans-serif';
export const wdsTheme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-mui-color-scheme',
    },
    typography: Object.assign(Object.assign({}, wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography), { fontFamily, button: {
            fontFamily,
        } }),
    colorSchemes: {
        light: Object.assign({ palette: Object.assign(Object.assign({}, (_b = (_a = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.colorSchemes) === null || _a === void 0 ? void 0 : _a.light) === null || _b === void 0 ? void 0 : _b.palette), { grey: paletteGrey }) }, generateCustomColors().light),
        dark: Object.assign({ palette: Object.assign(Object.assign({}, (_d = (_c = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.colorSchemes) === null || _c === void 0 ? void 0 : _c.dark) === null || _d === void 0 ? void 0 : _d.palette), { grey: paletteGrey, background: Object.assign(Object.assign({}, (_g = (_f = (_e = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.colorSchemes) === null || _e === void 0 ? void 0 : _e.dark) === null || _f === void 0 ? void 0 : _f.palette) === null || _g === void 0 ? void 0 : _g.background), { paper: '#101114' }) }), overlays: darkOverlays }, generateCustomColors().dark),
    },
    components: {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    fontFamily,
                    width: '100%',
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    flexGrow: 1,
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#696F7E',
                    fontFamily,
                    fontSize: (_j = (_h = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _h === void 0 ? void 0 : _h.body2) === null || _j === void 0 ? void 0 : _j.fontSize,
                    lineHeight: (_l = (_k = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _k === void 0 ? void 0 : _k.body2) === null || _l === void 0 ? void 0 : _l.lineHeight,
                    fontWeight: 500,
                    width: '28px',
                    height: '28px',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily,
                    textTransform: 'none',
                },
                sizeSmall: {
                    fontSize: (_o = (_m = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _m === void 0 ? void 0 : _m.body2) === null || _o === void 0 ? void 0 : _o.fontSize,
                    lineHeight: (_q = (_p = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _p === void 0 ? void 0 : _p.body2) === null || _q === void 0 ? void 0 : _q.lineHeight,
                },
                sizeMedium: {
                    fontSize: (_s = (_r = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _r === void 0 ? void 0 : _r.body1) === null || _s === void 0 ? void 0 : _s.fontSize,
                    lineHeight: (_u = (_t = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _t === void 0 ? void 0 : _t.body1) === null || _u === void 0 ? void 0 : _u.lineHeight,
                },
                sizeLarge: {
                    fontSize: (_w = (_v = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _v === void 0 ? void 0 : _v.h5) === null || _w === void 0 ? void 0 : _w.fontSize,
                    lineHeight: (_y = (_x = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _x === void 0 ? void 0 : _x.h5) === null || _y === void 0 ? void 0 : _y.lineHeight,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontFamily,
                },
                sizeSmall: {
                    fontSize: (_0 = (_z = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _z === void 0 ? void 0 : _z.body2) === null || _0 === void 0 ? void 0 : _0.fontSize,
                    lineHeight: (_2 = (_1 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _1 === void 0 ? void 0 : _1.body2) === null || _2 === void 0 ? void 0 : _2.lineHeight,
                },
                sizeMedium: {
                    fontSize: (_4 = (_3 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _3 === void 0 ? void 0 : _3.body1) === null || _4 === void 0 ? void 0 : _4.fontSize,
                    lineHeight: (_6 = (_5 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _5 === void 0 ? void 0 : _5.body1) === null || _6 === void 0 ? void 0 : _6.lineHeight,
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: (_8 = (_7 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _7 === void 0 ? void 0 : _7.body2) === null || _8 === void 0 ? void 0 : _8.fontSize,
                    lineHeight: (_10 = (_9 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _9 === void 0 ? void 0 : _9.body2) === null || _10 === void 0 ? void 0 : _10.lineHeight,
                },
            },
        },
        MuiSelect: {
            defaultProps: { IconComponent: ArrowDown },
        },
        MuiAutocomplete: {
            defaultProps: { popupIcon: _jsx(ArrowDown, { fontSize: "small", sx: { marginTop: '2px' } }) },
        },
        MuiCssBaseline: {
            styleOverrides: (themeParam) => ({
                body: themeParam.palette.mode === 'dark' ? darkScrollbar() : null,
                div: {
                    scrollbarWidth: 'thin !important',
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: themeParam.palette.text.disabled,
                        borderRadius: themeParam.spacing(1.25),
                        '--webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.0)',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: themeParam.palette.text.secondary,
                        borderRadius: themeParam.spacing(1.25),
                        '--webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: themeParam.palette.text.primary,
                    },
                },
            }),
        },
        MuiAlert: {
            styleOverrides: {
                standardInfo: fixAlertColours('info', 'standard'),
                standardWarning: fixAlertColours('warning', 'standard'),
                standardSuccess: fixAlertColours('success', 'standard'),
                standardError: fixAlertColours('error', 'standard'),
                outlinedInfo: fixAlertColours('info', 'outlined'),
                outlinedWarning: fixAlertColours('warning', 'outlined'),
                outlinedSuccess: fixAlertColours('success', 'outlined'),
                outlinedError: fixAlertColours('error', 'outlined'),
                filledInfo: fixAlertColours('info', 'filled'),
                filledWarning: fixAlertColours('warning', 'filled'),
                filledSuccess: fixAlertColours('success', 'filled'),
                filledError: fixAlertColours('error', 'filled'),
                message: {
                    width: '100%',
                    fontSize: (_12 = (_11 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _11 === void 0 ? void 0 : _11.body1) === null || _12 === void 0 ? void 0 : _12.fontSize,
                    lineHeight: (_14 = (_13 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _13 === void 0 ? void 0 : _13.body1) === null || _14 === void 0 ? void 0 : _14.lineHeight,
                    padding: '10px 0',
                },
            },
            defaultProps: {
                iconMapping: {
                    error: _jsx(Error, {}),
                    warning: _jsx(Warning, {}),
                    success: _jsx(Check, {}),
                    info: _jsx(Info, {}),
                },
            },
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: Object.assign({}, (_15 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _15 === void 0 ? void 0 : _15.h6),
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: ({ theme }) => ({
                    padding: theme.spacing(2, 3, 3, 3),
                }),
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: ({ theme }) => ({
                    padding: theme.spacing(3, 3, 2, 3),
                }),
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontFamily,
                    '& ::placeholder': {
                        color: theme.palette.text.secondary,
                    },
                }),
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderColor: theme.vars.palette.divider,
                }),
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontFamily,
                    textTransform: 'none',
                    padding: theme.spacing(0.5, 1),
                    fontWeight: 500,
                }),
                sizeSmall: {
                    fontSize: (_17 = (_16 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _16 === void 0 ? void 0 : _16.body2) === null || _17 === void 0 ? void 0 : _17.fontSize,
                    lineHeight: (_19 = (_18 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _18 === void 0 ? void 0 : _18.body2) === null || _19 === void 0 ? void 0 : _19.lineHeight,
                },
                sizeMedium: {
                    fontSize: (_21 = (_20 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _20 === void 0 ? void 0 : _20.body1) === null || _21 === void 0 ? void 0 : _21.fontSize,
                    lineHeight: (_23 = (_22 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _22 === void 0 ? void 0 : _22.body1) === null || _23 === void 0 ? void 0 : _23.lineHeight,
                },
                sizeLarge: {
                    fontSize: (_25 = (_24 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _24 === void 0 ? void 0 : _24.h5) === null || _25 === void 0 ? void 0 : _25.fontSize,
                    lineHeight: (_27 = (_26 = wdsFigmaExport === null || wdsFigmaExport === void 0 ? void 0 : wdsFigmaExport.typography) === null || _26 === void 0 ? void 0 : _26.h5) === null || _27 === void 0 ? void 0 : _27.lineHeight,
                },
            },
        },
    },
});
//# sourceMappingURL=wdsTheme.js.map